<template>
  <span class="svg-ico-arrow-left">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.8538 6.51718C11.1394 6.2172 11.1278 5.74247 10.8278 5.45684C10.5278 5.17121 10.0531 5.18284 9.76743 5.48282L4.05449 11.4828C3.77871 11.7725 3.77871 12.2275 4.05449 12.5172L9.76743 18.5172C10.0531 18.8172 10.5278 18.8288 10.8278 18.5432C11.1278 18.2575 11.1394 17.7828 10.8538 17.4828L6.34714 12.7498H20.5978C21.012 12.7498 21.3478 12.414 21.3478 11.9998C21.3478 11.5855 21.012 11.2498 20.5978 11.2498H6.34761L10.8538 6.51718Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
